const template = {
    de: "<h3>Freigabe Pressemitteilung</h3>"+
        "<p>Pressemitteilung <strong>%title%</strong> wurde freigegeben und kann weiterverarbeitet werden.</p>"+
        "<p>Name: %title%<br/>ID: %id%<br/>Pfad: %path%<br/>Status: %status%</p>",
    en: "<h3>Approved press release</h3>"+
        "<p>Press release <strong>%title%</strong> has been released and can be further processed.</p>"+
        "<p>Name: %title%<br/>ID: %id%<br/>Path: %path%<br/>State: %status%</p>"
};

const subject = {
    de: "Freigabe Pressemitteilung: ",
    en: "Approved press release: "
}

const mailTo = [
    'nick.weiss@flowworks.de',
    'alexandra.bleckmann@porsche.de',
    'alexander.merten@featuresandcreatures.com',
    'florian.bayer@featuresandcreatures.com',
    'schlichenmaier@siriusonline.de',
    'sirius-presse@siriusonline.de',
    'porsche@mediamoss.com'
];

export const sendMail = (data) => {
    // en as default
    let content = template["en"];//template[data.lang];
    
    for(let key in data) {
        content = content.replaceAll('%'+key+'%', data[key]);
    }
    
    const params = {
        from: "pm@pmdb-support.com",
        to: [ ...mailTo, data.email ].join(';'),
        subject: subject["en"]/*subject[data.lang]*/ + data["title"],
        html: content
    };
    console.log("Mail Params", params);
    
    //await flow.mail({'to':'nick.weiss@flowworks.de;info@dw-soft.de','html':'<h1>Test</h1>','subject':'check out','from': 'pm@pmdb-support.com'});
    window.flow.mail(params).then(res => {
        if(res.success) {
            console.log(res.msg);
        }
    }).catch(res => {
        console.log("Mail error", res);
    });
}
